export default "/images/a0b4149fb883b7d63f960c62d209c7ab.avif";